export const TOUR_STATUS = Object.freeze({
    NOT_STARTED: 'not_started',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    DISMISSED: 'dismissed',
});

export function normaliseStoragePart(value, fallback = 'unknown') {
    const normalised = String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9._-]+/g, '-')
        .replace(/^-+|-+$/g, '');

    return normalised || fallback;
}

export function buildScopedTourStorageKey({
    namespace = 'smartdata',
    tourId = '',
    version = 'v1',
    user = '',
    parts = [],
} = {}) {
    return [
        namespace,
        'tour',
        version,
        normaliseStoragePart(tourId, 'tour'),
        normaliseStoragePart(user),
        ...parts.map((part) => normaliseStoragePart(part)),
    ].join(':');
}

export function readTourState(
    storageKey,
    storage = window.localStorage,
    defaults = {}
) {
    if (!storage || !storageKey) {
        return { ...defaults };
    }

    const storedValue = storage.getItem(storageKey);
    if (!storedValue) {
        return { ...defaults };
    }

    try {
        return {
            ...defaults,
            ...JSON.parse(storedValue),
        };
    } catch (_error) {
        return { ...defaults };
    }
}

export function writeTourState(
    storageKey,
    nextState = {},
    storage = window.localStorage,
    defaults = {}
) {
    const mergedState = {
        ...defaults,
        ...nextState,
    };

    if (!storage || !storageKey) {
        return mergedState;
    }

    storage.setItem(storageKey, JSON.stringify(mergedState));
    return mergedState;
}
